import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import iconBlock from '@adsk/bim360-matrix-react-assets/icon-block.svg';
import iconCheck from '@adsk/bim360-matrix-react-assets/icon-check.svg';
import SvgIcon from '@adsk/bim360-matrix-react-svg-icon';
import i18n from '../../../utils/i18n';

const IssueRootCausesAdminStatus = props => {
  const label = props.isActive
    ? i18n.t('issueRootCauses.statuses.active')
    : i18n.t('issueRootCauses.statuses.inactive');
  const icon = props.isActive ? iconCheck : iconBlock;
  const className = cx('IssueRootCausesAdminStatus', {
    'IssueRootCausesAdminStatus--disabled': props.disabled,
    'IssueRootCausesAdminStatus--active': !props.disabled && props.isActive,
    'IssueRootCausesAdminStatus--inactive': !props.disabled && !props.isActive
  });

  return (
    <div className={className}>
      <SvgIcon width="16px" height="16px">
        {icon}
      </SvgIcon>
      {label}
    </div>
  );
};

IssueRootCausesAdminStatus.displayName = 'IssueTypesAdminStatus';

IssueRootCausesAdminStatus.defaultProps = {
  disabled: false
};

IssueRootCausesAdminStatus.propTypes = {
  isActive: PropTypes.bool.isRequired,
  disabled: PropTypes.bool
};

export default IssueRootCausesAdminStatus;
